export const system_api = {
  delay: 500,
  queryTimeout: 1000 * 60 * 2,
  exportTimeout: 1000 * 60 * 30,
};

export const system_toast = {
  life: 5000,
};

export const system_dropdown = {
  empty: "無資料",
  emptyFilter: "查無資料",
};

export const system_table = {
  empty: "無資料",
  size: 10,
  category_size: 12,
};

export const system_email = {
  valid: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
};

export const system_file_type = {
  img: ["png", "jpg", "jpeg", "bmp", "gif"],
};

export const system_chart = {
  colors: [
    "#6a92d2",
    "#acc9f8",
    "#f8b87d",
    "#ffd4ac",
    "#b2b0e2",
    "#c4c1f8",
    "#ff8080",
    "#fba4a4",
    "#3ea5b1",
    "#59bfcb",
    "#6cd4b2",
    "#a5e49e",
    "#afdabf",
    "#ebdf70",
    "#f4e0a4",
    "#fcf295",
    "#a47777",
    "#a99b9b",
    "#ccacac",
    "#ded0d0",
    "#f5f5dc",
    "#d2691e",
    "#d08b5a",
  ],
  pie: {
    minLimit: 5,
    minShow: 6,
    maxPer: 75,
  },
};
